export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
export const LEVELS = {
  0: "Floor 1",
  1: "Floor 2",
};
export const PAGE_SIZE = 8;

export const PROJECT_TYPE = {
  700000000: "DOD",
  700000001: "VA",
  // 2: 'OTH'
};
export enum REQUEST_ACTION_TYPE {
  // APPROVE = "approve",
  // DENY = "deny",
  PENDING = 1,
  PENDINGFINALAPPROVAL = 2,
  APPROVE = 3,
  REJECT = 4
}
export const DRAWING_TYPES = [
  {
    label: "PDF",
    value: 1,
  },
  {
    label: "REVIT",
    value: 2,
  },
  {
    label: "AutoCAD",
    value: 3,
  },
  {
    label: "Rendering/Photo",
    value: 4,
  },
  {
    label: "Other",
    value: 5,
  },
];

export const OUTLET_TYPE = [
  { value: 700000001, name: "5-15" },
  { value: 700000000, name: "5-20" },
  { value: 700000002, name: "5-30" },
  { value: 700000003, name: "5-50" },
  { value: 700000004, name: "6-15" },
  { value: 700000005, name: "6-20" },
  { value: 700000006, name: "6-30" },
  { value: 700000007, name: "14-20" },
  { value: 700000008, name: "14-30" },
  { value: 700000009, name: "14-50" },
  { value: 700000010, name: "14-60" },
  { value: 700000011, name: "L5-15" },
  { value: 700000012, name: "L5-20" },
  { value: 700000013, name: "L5-30" },
  { value: 700000014, name: "L14-20" },
  { value: 700000015, name: "L14-30" },
  { value: 700000016, name: "L6-15" },
  { value: 700000017, name: "L6-20" },
  { value: 700000019, name: "L6-30" },
  { value: 700000022, name: "L6-50" },
];

export const AMPS = [
  { name: "5", value: 700000000 },
  { name: "10", value: 700000001 },
  { name: "15", value: 700000002 },
  { name: "20", value: 700000003 },
  { name: "25", value: 700000004 },
  { name: "30", value: 700000005 },
  { name: "35", value: 700000006 },
  { name: "40", value: 700000007 },
  { name: "45", value: 700000008 },
  { name: "50", value: 700000009 },
  { name: "55", value: 700000010 },
  { name: "60", value: 700000011 },
  { name: "65", value: 700000012 },
  { name: "70", value: 700000013 },
  { name: "75", value: 700000014 },
  { name: "80", value: 700000015 },
  { name: "85", value: 700000016 },
  { name: "90", value: 700000017 },
  { name: "95", value: 700000018 },
  { name: "100", value: 700000019 },
];

export const DRAINSIZE = [
  { name: '2"', value: 1 },
  { name: '3"', value: 2 },
  { name: '4"', value: 3 },
  { name: '5"', value: 4 },
  { name: "N/A", value: 5 },
];
export const CHANGE_TYPES = [
  "",
  "JSN ADD",
  "JSN MODIFIED",
  "QUANTITY CHANGE",
  "JSN DELETED",
  "POSITIONAL CHANGE"
];

export enum APPROVAL_STATUS {
  PENDING_APPROVAL = 1,
  PENDING_CFG_FINAL_APPROVAL = 2,
  APPROVED = 3,
  REJECTED = 4
}
export enum FOLDER_MODE {
  ADD = 1,
  EDIT = 2,
}

export enum NOTE_TYPE {
  PROJECT = 1,
  DEPARTMENT = 2,
  ROOM = 3,
}

export enum FOLDER_TYPE {
  DELIVERABLES = 1,
  DRAWINGS = 2,
  MEETINGS = 3,
  REPORTS = 4,
  SCHEDULES = 5,
  ACQUISITIONS = 6,
}

export enum ROLE_ACCESS {
  TRUE = "YES",
  FALSE = "NO",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}
export enum MANAGE_MENU {
  MANAGE_USERS = 0,
  SECURITY_ROLES = 1,
}
export const CHANGED_FIELDS = {
  iota_acquisitionid: "CAT CODE",
  iota_mtr: "MTR",
  iota_inchesheight: "HEIGHT",
  iota_incheswidth: "WIDTH",
  iota_inchesdepth: "DEPTH",
  iota_amps1: "UTILITY AMPS",
  iota_comments: "JSN COMMENTS",
  iota_data: "UTILITY DATA",
  iota_description: "DESCRIPTION",
  iota_name: "NAME",
  iota_nomenclature: "NOMENCLATURE",
  iota_numberofdrops: "UTILITY NUMBER OF DROPS",
  iota_suffix: "OTHER",
  iota_utility_1: "UTILITY 1",
  iota_utility_2: "UTILITY 2",
  iota_utility_3: "UTILITY 3",
  iota_utility_4: "UTILITY 4",
  iota_utility_5: "UTILITY 5",
  iota_utility_6: "UTILITY 6",
};

export const TAKE = 5;
